import PropTypes from 'prop-types';

const StringOrNumberType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
]);

export const GuestType = PropTypes.shape({
  id: PropTypes.number,
  snap_id: PropTypes.number,
  location_id: PropTypes.number,
  isMember: PropTypes.number,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  dob: PropTypes.string,
  homeless: PropTypes.number,
  street_address: PropTypes.string,
  apartment: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipcode: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  workphone: PropTypes.string,
  cellphone: PropTypes.string,
  household_total: PropTypes.number,
  publicUser: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    otherInfo: PropTypes.shape({
      streetAddress: PropTypes.string,
      apartment: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
      county: PropTypes.string,
      homeless: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      homePhone: PropTypes.string,
      workPhone: PropTypes.string,
      cellPhone: PropTypes.string
    })
  })
});

export const MemberType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  age: PropTypes.string,
  rel: PropTypes.string,
  race: StringOrNumberType,
  gender: StringOrNumberType,
  note: PropTypes.string
});

export const ColumnSettingsType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  fieldType: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  position: PropTypes.number,
  isRequired: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array])
});
